import type { SkeletonProps as _SkeletonProps } from "@chakra-ui/react";
import { forwardRef, Skeleton as _Skeleton } from "@chakra-ui/react";

export interface SkeletonProps extends _SkeletonProps {}

export const Skeleton = forwardRef<SkeletonProps, "div">(({ ...props }, ref) => (
    <_Skeleton ref={ref} {...props} />
));
